const authFail = resolve => require(['@/views/ppAuthorization/index'], resolve) // 主页

export default [
  {
    path: '/authFail',
    component: authFail
  }
]
